module.exports = __webpack_public_path__ + "static/media/laptop.2ca6defa.jpg";